import request from '@/utils/request'
import baseUrl from './baseUrl'

const BASE_URL = baseUrl;
export default {
  getGuid() {
    return request({
      url: BASE_URL + '/GetGuid'
    })
  },
  getDictionaryList(data = {}) {
    return request({
      url: BASE_URL + '/Dictionary/List',
      method: 'post',
      data
    })
  },
  uploadPhotoUrl: "/Common/UploadPhoto",
  deletePhoto(path) {
    return request({
      url: BASE_URL + '/Common/DeletePhoto',
      params: {
        path
      }
    })
  },
  uploadPictureUrl: '/api/Common/UploadPicture',
  uploadPicture(data) {
    return request({
      url: BASE_URL + '/Common/UploadPicture',
      method: 'post',
      headers: { "Content-Type": "multipart/form-data" },
      data
    })
  }
}